 <template>
   <el-dialog
		:visible="showDialog"
		:before-close="purchaseBeforeCloseEvent"
		width="65%"
		modal-append-to-body
		class="add-purchase-item">
		<div slot="title" class="dialog-title">新增采购明细</div>
		<div class="add-purchase-item-content">
			<div class="content-left">
				<el-row>
					<el-input v-model="addPurchaseItemControl.keywords" size="mini" placeholder="" prefix-icon="el-icon-search"></el-input>
				</el-row>
				<el-row :gutter="5">
					<el-col :span="12">
						<div class="bm bm-ac">
							基础品类：
							<el-select v-model="addPurchaseItemControl.baseCategoryIndex" @change="chooseBaseCategoryEvent" clearable size="mini" placeholder="请选择">
								<el-option :key="item.id" v-for="(item, index) in baseCategoryList" :label="item.categoryName" :value="index"></el-option>
							</el-select>
						</div>
					</el-col>
					<el-col :span="12">
						<div class="bm bm-ac">
							一级类目：
							<el-select v-model="addPurchaseItemControl.firstCategoryIndex" @change="chooseFirstCategoryEvent" size="mini" clearable placeholder="请选择">
								<el-option :key="item.id" v-for="(item, index) in firstCategoryList" :label="item.categoryName" :value="index"></el-option>
							</el-select>
						</div>
					</el-col>
				</el-row>
				<div class="content-left-info">
                    <div v-if="secondCategoryList.length > 0">
                        <div v-for="(item,index) in secondCategoryList"  :key="index" class="content-left-info-item" >
                            <el-checkbox @click.native.prevent="chooseThirdCategoryEvent(item)" :value="addPurchaseItemControl.selectedItems.includes(item)"></el-checkbox>
                            <div class="content-left-info-item-name">
                                {{baseCategoryList[item._baseIndex] && baseCategoryList[item._baseIndex].categoryName}}_
                                {{baseCategoryList[item._baseIndex] && baseCategoryList[item._baseIndex].categoryList[item._firstIndex].categoryName}}_<span>{{item.categoryName}}</span>
                            </div>
                        </div>
                    </div>
					<div v-else class="empty bm bm-ac bm-pc">
						没有您要查找的设备
					</div>
				</div>
			</div>
			<div class="content-right">
				<div class="content-right-title">已选：</div>
				<div class="content-right-info">
					<div :key="item.id" v-for="item in addPurchaseItemControl.selectedItems" class="content-right-info-item">
						<div class="content-right-info-item-name">
							{{baseCategoryList[item._baseIndex].categoryName}}_
							{{baseCategoryList[item._baseIndex].categoryList[item._firstIndex].categoryName}}_<span>{{item.categoryName}}</span>
						</div>
						<div @click="removeCategoryEvent(item)" class="content-right-info-item-close el-icon-close"></div>
					</div>
				</div>
			</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="cancelPurchaseEvent">取 消</el-button>
			<el-button type="primary" @click="surePurchaseEvent">确 定</el-button>
		</span>
	</el-dialog>
</template>
<script>
// const R = require('ramda')
import  '@/utils/loadMore.js';
import { researchApi } from "@/services";
import { setTimeout } from 'timers';
import { debug } from 'util';
import { mapState } from "vuex";
export default {
    name: "chooseCate",
    props: {
        //是否展示框
        showDialog: {
            type: Boolean
        },
        section:{
            type: Array
        }

    },
    data () {
        return {
            addPurchaseItemControl: {
                visible: false,
                keywords: "",
                baseCategoryIndex: null,
                firstCategoryIndex: null,
                selectedItems: [],
            }
        };
    },
    watch:{
        showDialog(val){
            if(val){
                this.addPurchaseItemControl.selectedItems=[]
                this.section.forEach((item,i)=>{
                    this.addPurchaseItemControl.selectedItems.push(this.secondCategoryList.filter(res=>res.id==item.chargeItemCode)[0])
                })
   
            }
        }
    },
    computed: {
        ...mapState({
            baseCategoryList(state) {
                if (!this.$store.state.status.categoryList) {
                    this.$store.dispatch("getCategoryList");
                }
                return this.$store.state.status.categoryList || [];
            },
        }),

        firstCategoryList(state) {
            if (!this.baseCategoryList || this.baseCategoryList.length <= 0) {
                return [];
            }
            if (typeof this.addPurchaseItemControl.baseCategoryIndex != "number") {
                let list = [];
                this.baseCategoryList.forEach((item, index) => {
                    for (const subitem of item.categoryList) {
                        subitem.baseCategoryIndex = index;
                        list.push(subitem);
                    }
                });
                return list;
            }
            this.baseCategoryList[this.addPurchaseItemControl.baseCategoryIndex].categoryList.forEach((item, index) => {
                item.baseCategoryIndex = this.addPurchaseItemControl.baseCategoryIndex;
            });
            return this.baseCategoryList[this.addPurchaseItemControl.baseCategoryIndex].categoryList || [];
        },
        secondCategoryList(state) {
            if (!this.baseCategoryList || this.baseCategoryList.length <= 0) {
                return [];
            }
            let results = [];
            // 选择了一级分类
            if (typeof this.addPurchaseItemControl.firstCategoryIndex == "number") {
                if (!this.addPurchaseItemControl.keywords) {
                    return this.firstCategoryList[this.addPurchaseItemControl.firstCategoryIndex].categoryList || [];
                } else {
                    for (let item of this.firstCategoryList[this.addPurchaseItemControl.firstCategoryIndex].categoryList) {
                        if (item.categoryName.indexOf(this.addPurchaseItemControl.keywords) !== -1) {
                            results.push(item);
                        }
                    }
                }
                return results;
            }
            // 选择了基础分类
            if (typeof this.addPurchaseItemControl.baseCategoryIndex == "number") {
                if (!this.addPurchaseItemControl.keywords) {
                    for (const item of this.firstCategoryList) {
                        results = results.concat(item.categoryList);
                    }
                } else {
                    for (let item of this.firstCategoryList) {
                        for (const subItem of item.categoryList) {
                            if (item.categoryName.indexOf(this.addPurchaseItemControl.keywords) !== -1 || subItem.categoryName.indexOf(this.addPurchaseItemControl.keywords) !== -1) {
                                results.push(subItem);
                            }
                        }
                    }
                }
                return results;
            }
            // 输入了搜索条件
            if (this.addPurchaseItemControl.keywords) {
                for (const item of this.baseCategoryList) {
                    for (const subitem of item.categoryList) {
                        for (const thirditem of subitem.categoryList) {
                            if (item.categoryName.indexOf(this.addPurchaseItemControl.keywords) !== -1 || subitem.categoryName.indexOf(this.addPurchaseItemControl.keywords) !== -1 || thirditem.categoryName.indexOf(this.addPurchaseItemControl.keywords) !== -1) {
                                results.push(thirditem);
                            }
                        }
                    }
                }
                return results;
            }
            // 没有搜索条件
            for (const item of this.baseCategoryList) {
                for (const subitem of item.categoryList) {
                    results = results.concat(subitem.categoryList);
                }
            }
            return results;
        },
    },
    mounted () {
        let that = this;
    },
    methods: {
        // 选择基础品类
        chooseBaseCategoryEvent(value) {
            this.addPurchaseItemControl.firstCategoryIndex = null;
        },
        // 选择一级类目
        chooseFirstCategoryEvent(value) {
            // this.addPurchaseItemControl.baseCategoryIndex = this.firstCategoryList[value].baseCategoryIndex
        },
        // 选择二级类目
        chooseThirdCategoryEvent(item) {
            if (this.addPurchaseItemControl.selectedItems.includes(item)) {
                this.addPurchaseItemControl.selectedItems.splice(this.addPurchaseItemControl.selectedItems.indexOf(item), 1);
            } else {
                this.addPurchaseItemControl.selectedItems.push(item);
            }
        },
        // 移除选择的二级类目
        removeCategoryEvent(item) {
            this.addPurchaseItemControl.selectedItems.splice(this.addPurchaseItemControl.selectedItems.indexOf(item), 1);
        },
        purchaseBeforeCloseEvent(done) {
            this.addPurchaseItemControl.selectedItems.splice(0, this.addPurchaseItemControl.selectedItems.length);
            done();
            this.$emit("beClose")
        },
        // 取消品类选择
        cancelPurchaseEvent() {
            this.addPurchaseItemControl.visible = false;
            this.addPurchaseItemControl.selectedItems.splice(0, this.addPurchaseItemControl.selectedItems.length);
            this.$emit("beClose");
        },
        // 确定选择品类
        surePurchaseEvent() {
            let arr=JSON.parse(JSON.stringify(this.addPurchaseItemControl.selectedItems))
            this.$emit("confirm",arr)
            this.addPurchaseItemControl.selectedItems.splice(0, this.addPurchaseItemControl.selectedItems.length);

        }
    }
};
</script>
<style lang="scss" scoped>
.add-purchase-item-content {
    position: relative;
    &:after {
        position: absolute;
        content: "";
        top: 0px;
        left: -10px;
        right: -10px;
        border-bottom: 1px solid #dcdfe5;
    }
    display: flex;
    .content-left {
        width: 60%;
        word-break: keep-all;
        box-sizing: border-box;
        padding-right: 21px;
        position: relative;
        &:after {
            position: absolute;
            content: "";
            right: 0px;
            top: 0px;
            bottom: -84px;
            border-right: 1px solid #dcdfe5;
        }
        .el-row {
            margin-top: 10px;
        }
        .content-left-info {
            height: 300px;
            overflow: auto;
            margin-top: 35px;
            .content-left-info-item {
                width: 100%;
                display: flex;
                align-items: center;
                &:not(:first-child) {
                    margin-top: 20px;
                }
                .content-left-info-item-name {
                    margin-left: 11px;
                    flex: 1;
                    width: 0px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    word-break: keep-all;
                    font-size: 14px;
                    color: #323232;
                    span {
                        font-weight: bold;
                    }
                }
            }
            .loading, .finished{
                margin-top: 15px;
                font-size: 14px;
                text-align: center;
                padding: 10px 0;
            }
            .empty {
                margin-top:115px;
                font-size: 14px;
                text-align: center;
                padding: 10px 0;
            }
        }
    }
    .content-right {
        width: 40%;
        padding: 20px 3px 0px 17px;
        .content-right-title {
            font-size: 14px;
            color: #969696;
        }
        .content-right-info {
            margin-top: 15px;
            overflow: auto;
            min-height: 200px;
            max-height: 360px;
            .content-right-info-item {
                width: 100%;
                display: flex;
                align-items: center;
                box-sizing: border-box;
                padding: 9px 13px 9px 13px;
                background-color: #f0f2f5;
                border-radius: 4px;
                &:not(:first-child) {
                    margin-top: 10px;
                }
                .content-right-info-item-name {
                    flex: 1;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    word-break: keep-all;
                    font-size: 14px;
                    color: #323232;
                    span {
                        font-weight: bold;
                    }
                }
                .content-right-info-item-close {
                    cursor: pointer;
                    margin-left: 10px;
                    position: relative;
                    overflow: unset;
                    &::after {
                        cursor: pointer;
                        content: "";
                        position: absolute;
                        top: -12px;
                        bottom: -12px;
                        left: -12px;
                        right: -12px;
                    }
                }
            }
        }
    }
}
	
</style>
